export default "__VITE_ASSET__BEwj6cM2__"